<template>
  <div class="pp-stack" data-test="pp-tab-communication">
    <div class="pp-chips" role="group" aria-label="Filter by channel">
      <button
        v-for="f in visibleFilters"
        :key="f.key"
        type="button"
        class="pp-chip"
        :class="{ 'pp-chip--on': filter === f.key }"
        :aria-pressed="filter === f.key ? 'true' : 'false'"
        :data-test="`pp-comm-filter-${f.key}`"
        @click="filter = f.key"
      >{{ f.label }}</button>
    </div>

    <PanelCard test-id="pp-commlog" table>
      <ul v-if="rows.length" class="pp-msgs">
        <li v-for="(c, i) in rows" :key="i" class="pp-msg" data-test="pp-comm-row">
          <span class="pp-msg__ch" :class="`pp-msg__ch--${mode(c).key}`" aria-hidden="true">
            <i class="fa" :class="icon(c)"></i>
          </span>
          <div class="pp-msg__main">
            <div class="pp-msg__top">
              <span class="pp-msg__type">{{ c.Type || mode(c).label }}</span>
              <span class="pp-pill pp-pill--slate">{{ mode(c).label }}</span>
              <span v-if="direction(c)" class="pp-msg__dir" data-test="pp-comm-direction">{{ direction(c) }}</span>
              <span v-if="c.UserName" class="pp-msg__who">{{ c.UserName }}</span>
              <span class="pp-msg__when">{{ when(c.CommDateTime) }}</span>
            </div>
            <p v-if="c.Note" class="pp-msg__body">{{ c.Note }}</p>
          </div>
        </li>
      </ul>
      <p v-else class="pp-empty">{{ all.length ? 'Nothing on this channel.' : 'No communication logged in Open Dental.' }}</p>
    </PanelCard>

    <p class="pp-footnote">
      Open Dental's communication log, newest first (the latest 50 entries). Teamio texts and emails
      are not shown here yet.
    </p>
  </div>
</template>

<script>
/**
 * Communication — Open Dental's commlog, from Patient Profile's own query (latest 50).
 *
 * The design's Teamio channel and the reminders/confirmations timeline are NOT here: nothing in
 * Patient Profile loads them (Phase 7 decision, 2026-09-25), and the footnote says so rather than
 * letting an empty "Text" filter imply the patient was never texted.
 *
 * ⛔ No prop named `patNum`, `siteID` or `loading` — mixin.js computeds silently replace them.
 */
import PanelCard from '../PanelCard.vue';
import {
  commlogMode, commlogDirection, COMMLOG_FILTERS, filterCommlog, formatOdDateTime,
} from '@/utils/patientPanel/format';

const ICON = { phone: 'fa-phone', text: 'fa-comment', email: 'fa-envelope-o', other: 'fa-sticky-note-o' };

export default {
  name: 'CommunicationTab',

  components: { PanelCard },

  props: {
    payload: { type: Object, default: () => ({}) },
    dateFormat: { type: String, default: 'MM/DD/YYYY' },
  },

  data() {
    return { filter: 'all', filters: COMMLOG_FILTERS };
  },

  computed: {
    all() {
      return (this.payload && this.payload.commlog) || [];
    },
    rows() {
      return filterCommlog(this.all, this.filter);
    },
    /** "Other" (mode 0 / unknown) only when there is something under it — the design's 8 chips otherwise. */
    visibleFilters() {
      return this.filters.filter(f => f.key !== 'other' || filterCommlog(this.all, 'other').length > 0);
    },
  },

  methods: {
    mode(c) {
      return commlogMode(c && c.Mode_);
    },
    direction(c) {
      return commlogDirection(c);
    },
    icon(c) {
      return ICON[this.mode(c).key] || ICON.other;
    },
    when(v) {
      return formatOdDateTime(v, this.dateFormat);
    },
  },
};
</script>
